module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_flower_wall_an-e674e093e9b6eca3f69ef1de47f6d78b.jpg";